export const inventoryConstants = {
    inventoryType: {
        NEW: "New",
        USED: "Used",
    },
    saleType: {
        RETAIL: "Retail",
        WHOLESALE: "Wholesale",
    }
}